import React, { useEffect, useState } from 'react'
import '../Style/Index.css'
import Product_List from '../Components/Product_List'
import LoadingScreen from '../Components/Loading_Screen'
import Blog_Section from '../Components/Blog_Section'
import Loading_Screen from '../Components/Loading_Screen'
import Por_Takhfif from '../Components/Por_Offer_Com'
import Shoar from '../Components/Shoar_Com'
import Suggested_Products from '../Components/Suggested_Products'

function Main() {
    const [Loading, SetLoading] = useState(true)
    return (
        <>
            <main onLoad={() => {SetLoading(false)}}>
                <Suggested_Products />
                {Loading? <Loading_Screen /> : null}
                <Por_Takhfif />
                {/* {isloading ? <LoadingScreen /> : null} */}
                <Product_List />
                <Blog_Section />
                <Shoar />
            </main>
        </>
    )
}

export default Main